var _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkyscraperBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    id: "svg1611",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1615"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1625"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path1623"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "custom"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,1,140,387)",
    d: "m 0,0 v 0 c -11.046,0 -20,8.954 -20,20 0,11.046 8.954,20 20,20 C 11.046,40 20,31.046 20,20 20,8.954 11.046,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120,314 H 80 v 40 h 40 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 200,314 h -40 v 40 h 40 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120,235 H 80 v 40 h 40 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 200,235 h -40 v 40 h 40 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120,156 H 80 v 40 h 40 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 200,156 h -40 v 40 h 40 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120,77 H 80 v 40 h 40 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 200,77 h -40 v 40 h 40 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 356,235 h -40 v 40 h 40 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1655"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,1,376,310)",
    d: "m 0,0 v 0 c -11.046,0 -20,8.954 -20,20 0,11.046 8.954,20 20,20 C 11.046,40 20,31.046 20,20 20,8.954 11.046,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 436,235 h -40 v 40 h 40 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 356,156 h -40 v 40 h 40 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 436,156 h -40 v 40 h 40 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 356,77 h -40 v 40 h 40 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 436,77 h -40 v 40 h 40 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1669"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#custom)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1617",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1621",
    clipPath: "url(#clipPath1625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1627",
    transform: "translate(260,20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -240 V 399 L -120,469 0,399 Z",
    style: {
      fill: "none",
      stroke: "#5555FF",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1631",
    transform: "translate(140,387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0 c -11.046,0 -20,8.954 -20,20 0,11.046 8.954,20 20,20 C 11.046,40 20,31.046 20,20 20,8.954 11.046,0 0,0",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1633"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 120,314 H 80 v 40 h 40 z",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 200,314 h -40 v 40 h 40 z",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120,235 H 80 v 40 h 40 z",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 200,235 h -40 v 40 h 40 z",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120,156 H 80 v 40 h 40 z",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 200,156 h -40 v 40 h 40 z",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120,77 H 80 v 40 h 40 z",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 200,77 h -40 v 40 h 40 z",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1649"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1651",
    transform: "translate(252,344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 124,70 240,0 V -324 H 0",
    style: {
      fill: "none",
      stroke: "#5555FF",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1653"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 356,235 h -40 v 40 h 40 z",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1655"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1657",
    transform: "translate(376,310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0 c -11.046,0 -20,8.954 -20,20 0,11.046 8.954,20 20,20 C 11.046,40 20,31.046 20,20 20,8.954 11.046,0 0,0",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1659"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 436,235 h -40 v 40 h 40 z",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 356,156 h -40 v 40 h 40 z",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 436,156 h -40 v 40 h 40 z",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 356,77 h -40 v 40 h 40 z",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 436,77 h -40 v 40 h 40 z",
    style: {
      fill: "#5555FF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1669"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyscraperBlue);
export default __webpack_public_path__ + "static/media/skyscraperBlue.d4fd012180cf63e4c69a3ef90174b020.svg";
export { ForwardRef as ReactComponent };